import { render, staticRenderFns } from "./detail-print.vue?vue&type=template&id=9b643c02&"
import script from "./detail-print.vue?vue&type=script&lang=js&"
export * from "./detail-print.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports